'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();

import { Button, Col, Container, Row } from 'reactstrap';
import JobNotFoundSvg from 'shared/components/svg/JobNotFoundSvg';
import capitalizeFirstLetter from 'shared/utils/capitalizeFirstLetter';
import { JobsSection } from 'shared/components/thankyou';
import useWindowWidth from 'shared/hooks/useWindowWidth';
import Link from 'next/link';
import OurOtherJobs from '../../components/svg/OurOtherJobs';
import { Dictionaries, Locale } from '../../i18n/i18n-config';
import { getI18nUtils } from '../../i18n/i18n-utils';

type Props = {
  jobTitle: string;
  matchingJobs: JobMatchResponse;
  numberOfJobs: number;
  dictionary: Partial<Dictionaries>;
  locale: Locale;
};
const JobNotFound = ({ dictionary, jobTitle, locale, matchingJobs, numberOfJobs }: Props) => {
  const { formatMessage } = getI18nUtils(dictionary);
  const width = useWindowWidth();

  return (
    <div id="jobnotfound">
      <section className="bg-light">
        <Container>
          <Row style={{ margin: 'auto' }}>
            <Col lg={{ size: 6, order: 2 }} className="d-flex justify-content-center align-items-center my-5 py-lg-3">
              <JobNotFoundSvg width={width} />
            </Col>
            <Col lg={{ size: 6, order: 1 }} className="d-flex flex-column justify-content-center align-items-start mt-lg-5 mb-5">
              <div className="mx-lg-3">
                <h1 className="mx-lg-5 px-lg-5 h3">
                  {formatMessage({ id: 'job_not_found_jobtitle' }, { jobTitle: capitalizeFirstLetter(jobTitle.trim()) })}
                </h1>
                {matchingJobs && matchingJobs.matches && matchingJobs.matches.length > 0 && (
                  <div className="mx-lg-5 px-lg-5 mt-3">{formatMessage({ id: 'job_not_found_other_jobs' })}</div>
                )}
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      {matchingJobs && matchingJobs.matches && matchingJobs.matches.length > 0 && (
        <Container>
          <div className="mt-5 mx-lg-5 px-lg-5">
            <JobsSection dictionary={dictionary} locale={locale} matchingJobs={matchingJobs.matches} />
          </div>
        </Container>
      )}
      <section className={`mt-5 pb-5 ${matchingJobs && matchingJobs.matches && matchingJobs.matches.length > 0 && 'bg-light'}`}>
        <Container>
          <Row className="pt-lg-5">
            <Col lg={{ size: 6 }} className="d-flex justify-content-center align-items-center my-5">
              <OurOtherJobs />
            </Col>
            <Col lg={{ size: 4 }} className="d-flex flex-column justify-content-center align-items-start">
              <div className="mb-3">{formatMessage({ id: 'job_not_found_all_jobs' }, { numberOfJobs })}</div>
              <Link href="/jobs">
                <div className="d-inline-block my-3">
                  <Button outline color="primary" size="sm">
                    {formatMessage({ id: 'candidates-why-apply-btn' })}
                  </Button>
                </div>
              </Link>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default JobNotFound;
